<script>
  let name;
  let method;
  let topic;
  let phone;
  let email;
  let comment;
  let showComment;

  let sending = false;
  let messageIsSend = false;
  let errors = {};

  function validateEmail(string) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(string)) {
      return true;
    }

    return false;
  }

  function validatePhone(string) {
    if (
      /^((\+|00(\s|\s?\-\s?)?)31(\s|\s?\-\s?)?(\(0\)[\-\s]?)?|0)[1-9]((\s|\s?\-\s?)?[0-9])((\s|\s?-\s?)?[0-9])((\s|\s?-\s?)?[0-9])\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]$/.test(
        string
      )
    ) {
      return true;
    }

    return false;
  }

  function validateForm() {
    return {
      ...(!name ? { name: "Vul je naam in." } : {}),
      ...(!method ? { method: "Kies voor bellen of mailen." } : {}),
      ...(!topic ? { topic: "Kies een onderwerp." } : {}),
      ...(method === "bellen" && !validatePhone(phone)
        ? { phone: "Vul een geldig telefoonnummer in." }
        : {}),
      ...(method === "e-mailen" && !validateEmail(email)
        ? { email: "Vul een geldig e-mailadres in." }
        : {}),
      ...(showComment && !comment
        ? { comment: "Vul jouw commentaar in of kies voor “Dat was het!”." }
        : {})
    };
  }

  const onSubmit = event => {
    event.preventDefault();

    sending = true;

    errors = validateForm();

    if (Object.keys(errors).length) {
      sending = false;
    } else {
      let message = "";

      message += `Hoi Rik, mijn naam is ${name}. `;
      message += `Ik wil graag met je ${method} over ${topic}. `;
      message += `Je kan mij ${method} op `;
      message += method === "bellen" ? phone : "";
      message += method === "e-mailen" ? email : "";
      message += showComment ? `. Verder: ${comment}` : ".";

      async function postData() {
        const response = await fetch("/contact/", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ message })
        });

        return await response.json();
      }

      sending = true;

      postData()
        .then(data => {
          sending = false;

          if (data.status === "success") {
            messageIsSend = true;
          } else {
            errors = { serverError: data.message };
          }
        })
        .catch(error => {
          sending = false;
          errors = {
            serverError: error
          };
        });
    }
  };
</script>

<article class="m-t-xxxxl p-b-xxxxl" id="contact">
  <h2 class="m-b-m">
    Kan ik iets
    {@html '<strong>voor je betekenen</strong>?'}
    Neem
    <strong>contact</strong>
    op.
  </h2>

  <form class="p-l" on:submit={onSubmit}>
    {#if !messageIsSend}
      <p>
        Mijn naam is
        <input
          type="text"
          bind:value={name}
          placeholder="naam"
          class:error={errors.name} />
        . Ik wil graag met je
        <select bind:value={method} class:error={errors.method}>
          <option value="" />
          <option>bellen</option>
          <option>e-mailen</option>
        </select>
        over
        <select bind:value={topic} class:error={errors.topic}>
          <option value="" />
          <option>een website</option>
          <option>een webapplicatie</option>
          <option>een kopje koffie</option>
          <option>iets anders</option>
        </select>
        .
        {#if method}
          Je kan mij
          {#if method === 'bellen'}
            bellen op
            <input
              type="text"
              bind:value={phone}
              placeholder="telefoonnummer"
              class:error={errors.phone} />
          {/if}
          {#if method === 'e-mailen'}
            e-mailen op
            <input
              type="text"
              bind:value={email}
              placeholder="e-mailadres"
              class:error={errors.email} />
          {/if}
          .
        {/if}

        <select bind:value={showComment}>
          <option value={false}>Dat was het!</option>
          <option value={true}>Verder wil ik nog iets kwijt</option>
        </select>

        {#if showComment}
          , namelijk:
          <textarea bind:value={comment} class:error={errors.comment} />
        {/if}
      </p>

      {#if name}
        <p>
          Groet,
          <br />
          {name}
        </p>
      {/if}

      {#if Object.keys(errors).length}
        <ul class="errors">
          {#each Object.keys(errors) as error}
            <li>{errors[error]}</li>
          {/each}
        </ul>
      {/if}

      <button type="submit" disabled={sending}>
        {sending ? 'Versturen…' : 'verstuur'}
      </button>
    {:else}
      <p>
        Dankjewel voor je bericht. Ik {method === 'bellen' ? 'bel' : 'mail'} je
        zo snel mogelijk over {topic}.
      </p>
      <p>
        Vriendelijke groet,
        <br />
        Rik
      </p>
    {/if}
  </form>
</article>
